import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ViewContainerRefService {
  private _viewContainerRef: ViewContainerRef | null = null;

  set(vcr: ViewContainerRef) {
    this._viewContainerRef = vcr;
  }

  get(): ViewContainerRef {
    if (!this._viewContainerRef) throw new Error('Root ViewContainerRef not set');
    return this._viewContainerRef;
  }
}
